import { ServiceHelper } from "../../Everou/_services/ServiceHelper";
import { ORGANIZATIONS_API_URLS } from "../_constants/ORGANIZATIONS_API_URLS";
import { OrganizationMemberRole } from "../_models/Organization";

export const OrganizationsService = {
    list,
    get,
    create,
    update,
    remove,
    addUser,
    removeUser,
    changeUserRole,
    addLocation,
    addAllLocations,
    removeLocation,
    availableLocations,
};

async function list() {
    return ServiceHelper.getRequest(ORGANIZATIONS_API_URLS.LIST);
}

async function get(uid: string) {
    return ServiceHelper.postRequest(ORGANIZATIONS_API_URLS.INFO, { uid });
}

async function create({ name }: { name: string }) {
    return ServiceHelper.postRequest(ORGANIZATIONS_API_URLS.CREATE, { name });
}

async function update({ uid, name }: { uid: string; name: string }) {
    return ServiceHelper.postRequest(ORGANIZATIONS_API_URLS.UPDATE, {
        uid,
        name,
    });
}

async function remove(uid: string) {
    return ServiceHelper.postRequest(ORGANIZATIONS_API_URLS.REMOVE, { uid });
}

async function addUser({
    uid,
    email,
    role,
}: {
    uid: string;
    email: string;
    role: OrganizationMemberRole;
}) {
    return ServiceHelper.postRequest(ORGANIZATIONS_API_URLS.USER_ADD, {
        uid,
        email,
        role,
    });
}

async function removeUser({ uid, userUid }: { uid: string; userUid: string }) {
    return ServiceHelper.postRequest(ORGANIZATIONS_API_URLS.USER_REMOVE, {
        uid,
        user_uid: userUid,
    });
}

async function changeUserRole({
    uid,
    userUid,
    role,
}: {
    uid: string;
    userUid: string;
    role: OrganizationMemberRole;
}) {
    return ServiceHelper.postRequest(ORGANIZATIONS_API_URLS.USER_ROLE, {
        uid,
        user_uid: userUid,
        role,
    });
}

async function addLocation({
    uid,
    locationUid,
}: {
    uid: string;
    locationUid: string;
}) {
    return ServiceHelper.postRequest(ORGANIZATIONS_API_URLS.LOCATION_ADD, {
        uid,
        loc_uid: locationUid,
    });
}

async function removeLocation({
    uid,
    locationUid,
}: {
    uid: string;
    locationUid: string;
}) {
    return ServiceHelper.postRequest(ORGANIZATIONS_API_URLS.LOCATION_REMOVE, {
        uid,
        loc_uid: locationUid,
    });
}

async function availableLocations(
    uid: string,
    {
        searchTerm,
        offset = 0,
        limit = 50,
    }: { searchTerm?: string; offset?: number; limit?: number } = {},
) {
    return ServiceHelper.postRequest(
        ORGANIZATIONS_API_URLS.AVAILABLE_LOCATIONS,
        {
            uid,
            ...(searchTerm ? { search_term: searchTerm } : {}),
            offset,
            limit,
        },
    );
}

async function addAllLocations(uid: string, searchTerm?: string) {
    return ServiceHelper.postRequest(ORGANIZATIONS_API_URLS.LOCATION_ADD_ALL, {
        uid,
        ...(searchTerm ? { search_term: searchTerm } : {}),
    });
}
